import AppImgBg from '../app-img-bg'
import AppBtn from '../app-btn'

export default
{
    name: 'app-season-coming-soon',

    components:
    {
        AppImgBg,
        AppBtn
    },

    data()
    {
        return {
            content: this.$root.contentGlobal.comingSoon,
            deadline: this.$root.contentGlobal.comingSoon.startTime * 1000,
            dateNow: 0,
            countdown: {
                daysString: '00',
                days: 0,
                hoursString: '00',
                hours: 0,
                minutesString: '00',
                minutes: 0,
                secondsString: '00',
                seconds: 0,
                milliseconds: 0
            }
        }
    },

    computed:
    {
        titleStylized()
        {
            return `Season <span class="u-color--red">${this.content.number}</span>`
        }
    },

    created()
    {
        this.eventHub.$on('application:on-frame', this._onEnterFrame)
    },

    destroyed()
    {
        this.eventHub.$off('application:on-frame', this._onEnterFrame)
    },

    methods:
    {
        _onEnterFrame()
        {
            this.dateNow = new Date().getTime()

            // Get the difference in milliseconds between the deadline and dateNow
            this.countdown.milliseconds = this._getMilliseconds()

            if (this.countdown.milliseconds > 0)
            {
                // If it's in future
                if (this.countdown.seconds !== this._getSeconds())
                {
                    // If it's a new seconds
                    this.countdown.seconds = this._getSeconds()
                    this.countdown.minutes = this._getMinutes()
                    this.countdown.hours = this._getHours()
                    this.countdown.days = this._getDays()

                    this.countdown.secondsString = this.countdown.seconds < 10 ? `0${this.countdown.seconds}` : this.countdown.seconds
                    this.countdown.minutesString = this.countdown.minutes < 10 ? `0${this.countdown.minutes}` : this.countdown.minutes
                    this.countdown.hoursString = this.countdown.hours < 10 ? `0${this.countdown.hours}` : this.countdown.hours
                    this.countdown.daysString = this.countdown.days < 10 ? `0${this.countdown.days}` : this.countdown.days
                }
            }

            this.eventHub.$emit('app-season-coming-soon:countdown-update', this.countdown)
        },

        _getMilliseconds()
        {
            return this.deadline - this.dateNow
        },

        _getSeconds()
        {
            return Math.floor((this.countdown.milliseconds % (1000 * 60)) / 1000)
        },

        _getMinutes()
        {
            return Math.floor((this.countdown.milliseconds % (1000 * 60 * 60)) / (1000 * 60))
        },

        _getHours()
        {
            return Math.floor((this.countdown.milliseconds % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        },

        _getDays()
        {
            return Math.floor(this.countdown.milliseconds / (1000 * 60 * 60 * 24))
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-season-coming-soon/script.js